import { render, staticRenderFns } from "./VideoManagement.vue?vue&type=template&id=55118208&scoped=true"
import script from "./VideoManagement.vue?vue&type=script&lang=js"
export * from "./VideoManagement.vue?vue&type=script&lang=js"
import style0 from "./VideoManagement.vue?vue&type=style&index=0&id=55118208&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55118208",
  null
  
)

export default component.exports